<template>
  <div>
    <h4>Cartão de Crédito</h4>
    <PaymentProviderNotice
      variant="redirect"
      message="Você será redirecionado para o PayPal para concluir o pagamento com cartão de crédito."
    />
    <CreditCardCustomerFields :basket="basket" />

    <vs-button type="relief" class="w-full mt-6" @click="pay">Continuar</vs-button>
  </div>
</template>

<script>
import CreditCardCustomerFields from '../CreditCardCustomerFields.vue';
import PaymentProviderNotice from '../PaymentProviderNotice.vue';
import { checkoutLog } from '../../utils/checkoutDebug';

export default {
  components: {
    CreditCardCustomerFields,
    PaymentProviderNotice
  },
  props: {
    checkoutWizard: {
      type: Object,
      required: true
    },
    paymentMethod: {
      type: String,
      required: true
    },
    basket: {
      type: Object,
      required: true
    }
  },
  mounted() {
    checkoutLog(
      'gateway:mounted',
      { gateway: 'PayPalSubscription', paymentMethod: this.paymentMethod },
      this.$route
    );
  },
  methods: {
    pay() {
      this.basket.processing = true;

      this.$api
        .post('/api/v1/checkout/order/create', {
          payment_method: this.paymentMethod,
          basket: this.basket,
          affiliate: localStorage.getItem('aff') || null
        })
        .then(response => {
          if (response.data && response.data.links) {
            window.location.href = response.data.links[0].href;
          } else {
            this.$vs.notify({
              time: 6000,
              text: 'Não foi possível processar seu pedido. Atualize a página e tente novamente.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
            this.basket.processing = false;
          }
        })
        .catch(error => {
          this.basket.processing = false;
          this.$EventBus.$emit('paymentProviderFailed', this.paymentMethod);

          let errors = [];
          if (error.response && error.response.data.message) {
            errors.push(error.response.data.message);
          } else if (error.response && error.response.data) {
            for (const key in error.response.data) {
              if (Object.hasOwnProperty.call(error.response.data, key)) {
                errors.push(error.response.data[key]);
              }
            }
          }

          this.$vs.notify({
            time: 6000,
            text: errors.join('<br>'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    }
  }
};
</script>
